import { cn } from '@/lib/utils';

// TODO: вкладка скрыта, задел на будущее
export function OrganizationDetailsTab() {
  return (
    <div className='space-y-3'>
      <h3 className='text-sm font-medium text-foreground mb-4'>Реквизиты организации</h3>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
        {[
          { label: 'ИНН', value: '7701234567', mono: true },
          { label: 'КПП', value: '770101001', mono: true },
          { label: 'ОГРН', value: '1234567890123', mono: true },
          { label: 'Расчётный счёт', value: '40702810000000123456', mono: true },
        ].map((item) => (
          <div key={item.label} className='p-3.5 bg-muted/30 border border-border/30 rounded-xl'>
            <p className='text-xs text-muted-foreground mb-1'>{item.label}</p>
            <p className={cn('text-sm text-foreground', item.mono && 'font-mono')}>{item.value}</p>
          </div>
        ))}
        <div className='md:col-span-2 p-3.5 bg-muted/30 border border-border/30 rounded-xl'>
          <p className='text-xs text-muted-foreground mb-1'>Банк</p>
          <p className='text-sm text-foreground'>ПАО &quot;Сбербанк России&quot;</p>
          <p className='text-xs text-muted-foreground mt-1 font-mono'>
            БИК: 044525225 / К/С: 30101810400000000225
          </p>
        </div>
        <div className='md:col-span-2 p-3.5 bg-muted/30 border border-border/30 rounded-xl'>
          <p className='text-xs text-muted-foreground mb-1'>Юридический адрес</p>
          <p className='text-sm text-foreground'>220000, г. Минск, ул. Ленина, д. 1, офис 100</p>
        </div>
      </div>
    </div>
  );
}
